<template>
  <div
    class="grid grid-cols-4 content-center items-center border-blue-200 border-solid border rounded-lg"
  >
    <div
      class="col-span-full md:col-span-1 text-indigo-600 text-lg font-normal flex justify-center py-5 px-10"
    >
      <p>{{ humanLabel }}</p>
    </div>

    <div
      class="col-span-full md:col-span-3 h-full border-blue-200 border-solid border-t md:border-t-0 md:border-l flex items-center"
    >
      <div>
        <div
          class="text-sm first:rounded-t-lg last:rounded-b-lg text-gray-900 odd:bg-white bg-indigo-100 bg-opacity-50 h-auto min-h-20 md:h-20 font-light"
          v-for="(criteria, index) in skill.criterions"
          :key="index"
        >
          <div
            class="flex flex-row h-auto min-h-20 md:h-20 items-center w-full"
          >
            <p
              class="mx-5 my-0.5"
              :class="{'w-9/10': !criteria.description, 'w-8/10': criteria.description}"
            >
              {{ criteria.value }}
            </p>
            <div
              v-if="criteria.description"
              class="w-1/10 mr-5 self-center"
            >
              <info-bulle
                :libelle="criteria.description"
                :name="`info${index}`"
                size-less
              />
            </div>
            <div class="mr-5 w-1/10 flex">
              <checkbox-indigo
                :name="'value' + mainIndex + secondaryIndex + index"
                :value="criteria.check"
                @input="handleInput($event, index)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CheckboxIndigo from '../../components/Inputs/CheckboxIndigo.vue';
import InfoBulle from '../../components/InfoBulle.vue';

export default {
  name: 'CleaSkill',

  components: { InfoBulle, CheckboxIndigo },

  props: {
    skill: {
      type: Object,
      required: true,
    },
    mainIndex: {
      type: Number,
      required: true,
    },
    secondaryIndex: {
      type: Number,
      required: true,
    },
  },

  emits: ['checked', 'unchecked'],

  methods: {
    /**
     * @param {Boolean} value
     * @param {Number} index
     */
    handleInput(value, index) {
      if (value) {
        this.$emit('checked', index);
      } else {
        this.$emit('unchecked', index);
      }
    },
  },

  computed: {
    humanLabel() {
      const indices = [this.mainIndex + 1, this.secondaryIndex + 1];
      return `${indices[0]}-${indices[1]}. ${this.skill.libelle}`;
    },
  },
};
</script>